import { connect } from 'react-redux';

import { PERMISSION, VENUE_SERVICE_TYPES } from 'constants/logic';
import { selectUserInfo, selectUserVenues, selectUserHasPermission, selectUserHasPermissions } from 'selectors/general';

import Notifications from './Notifications';
import {
  selectReceiveNotifications,
  selectUserSettingsIsLoaded,
  selectUserSmsSubscriptionStatusIsLoaded,
  selectUserSmsSubscriptionStatus,
  selectUserSmsPhoneNumber,
} from './Notifications.selectors';
import { updateNotifications as updateNotificationsAction } from './Notifications.saga';
import messages from './Notifications.messages';
import { NOTIFICATION_TYPE, NOTIFICATION_TYPE_LIST } from './Notifications.constants';

function mapStateToProps(state, ownProps) {
  const { userId } = selectUserInfo(state);
  const venues = selectUserVenues(state);
  const isLoaded = selectUserSettingsIsLoaded(state) && selectUserSmsSubscriptionStatusIsLoaded(state);
  const receiveNotifications = selectReceiveNotifications(state);
  const userSmsSubscriptionStatus = selectUserSmsSubscriptionStatus(state);
  const userPhoneNumber = selectUserSmsPhoneNumber(state);

  const canModifyOpportunityNotifications = selectUserHasPermission(state, PERMISSION.DISPLAY_SPOT_MANAGEMENT);
  const canReceiveWeeklyDigestEmail = selectUserHasPermissions(state, [
    PERMISSION.DISPLAY_SPOT_MANAGEMENT,
    PERMISSION.FEATURE_RATINGS_REVIEWS,
  ]);

  const notificationTypes = NOTIFICATION_TYPE_LIST.reduce((types, type) => {
    if (type === NOTIFICATION_TYPE.CAN_RECEIVE_DIGEST_EMAILS && !canReceiveWeeklyDigestEmail) {
      return types;
    }
    if (type === NOTIFICATION_TYPE.CAN_RECEIVE_OPPORTUNITY_EMAILS && !canModifyOpportunityNotifications) {
      return types;
    }
    const hasMsiVenue = venues.some(venue => !!venue.isMsInventoryVenue);
    if (type === NOTIFICATION_TYPE.CAN_RECEIVE_CHANGELOG_EMAILS && !hasMsiVenue) {
      return types;
    }
    const hasAppointmentVenue = venues.some(venue => !!venue.serviceTypes.includes(VENUE_SERVICE_TYPES.APPOINTMENT));
    if (type === NOTIFICATION_TYPE.CAN_RECEIVE_SMS && !hasAppointmentVenue) {
      return types;
    }
    return types.concat(type);
  }, []);

  const tagTrees = notificationTypes.reduce(
    (trees, type) => ({
      ...trees,
      [type]: venues
        // The changelog email setting only applies to MSI venues
        .filter(venue => type !== NOTIFICATION_TYPE.CAN_RECEIVE_CHANGELOG_EMAILS || venue.isMsInventoryVenue)
        .map(({ venueId, venueName, venueSubtitle }) => ({
          id: `${venueId}`,
          name: {
            ...messages.tag,
            values: {
              venueName,
              venueSubtitle: venueSubtitle || undefined,
            },
          },
        })),
    }),
    {}
  );

  return {
    ...ownProps,
    isLoading: !isLoaded,
    initialValues: {
      userId,
      userPhoneNumber,
      receiveNotifications,
      userSmsSubscriptionStatus,
    },
    tagTrees,
    notificationTypes,
    receiveNotifications,
    userSmsSubscriptionStatus,
    userPhoneNumber,
  };
}

const mapDispatchToProps = {
  updateNotifications: updateNotificationsAction,
};

const mergeProps = (stateProps, dispatchProps) => {
  const { initialValues, ...restStateProps } = stateProps;
  const { updateNotifications } = dispatchProps;
  return {
    ...restStateProps,
    handleSubmit: (formValues, formAsyncFns) => {
      const {
        receiveNotifications: currentReceiveNotifications,
        userSmsSubscriptionStatus: currentUserSmsSubscriptionStatus,
        userPhoneNumber: currentUserPhoneNumber,
      } = formValues;

      updateNotifications(
        { currentReceiveNotifications, currentUserSmsSubscriptionStatus, currentUserPhoneNumber, ...initialValues },
        formAsyncFns
      );
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(Notifications);
